//@ts-nocheck
import { getConfig } from "../config/config";
import { checkIsEmpty, uintToJson } from "../helpers";
import { SOCKET_EVENT } from "./constant";
const { APP_BASE_TTWEBSOCKET_WS_URL } = getConfig();
let feedSocketRef;
const subscriberList = [];
const scripMap = {};
let rawMessageListener = null;
let socketStatusListener = null;
let isDepthSocketConnected = false;
export const setRawMessageListener = (listener) => {
    rawMessageListener = listener;
};
export const setSocketStatusListener = (listener) => {
    socketStatusListener = listener;
};
export const getDepthSocketConnected = () => isDepthSocketConnected;
const publishMessage = (eventType, data, focusScripCode) => {
    if (feedSocketRef != undefined) {
        feedSocketRef.postMessage({
            eventType: eventType,
            data: data,
            focusScripCode: focusScripCode,
        });
    }
};
export const init5DepthSocket = () => {
    if (feedSocketRef == undefined) {
        feedSocketRef = new Worker(new URL("new_depth.worker.ts", import.meta.url));
        if (window.Worker) {
            const clientCode = localStorage.getItem("ClientCode");
            const swarajWsurl = `${APP_BASE_TTWEBSOCKET_WS_URL}api/chat?Value1=${clientCode}`;
            if (!APP_BASE_TTWEBSOCKET_WS_URL) {
                console.error("[DepthWrapper] APP_BASE_TTWEBSOCKET_WS_URL is undefined!");
                return;
            }
            if (!clientCode) {
                console.error("[DepthWrapper] ClientCode is not available in localStorage!");
                return;
            }
            publishMessage("CONNECT_SOCKET", {
                wsUrl: swarajWsurl,
                clientCode: clientCode,
            });
            feedSocketRef.onmessage = (e) => {
                var _a;
                try {
                    // Handle raw (non-encoded) messages from worker (e.g. networkCheckWebsocketError)
                    if (e.data && typeof e.data === 'object' && !(e.data instanceof Uint8Array)) {
                        if (e.data.networkCheckWebsocketError || e.data.networkCheckWebsocketRetry) {
                            if (isDepthSocketConnected !== false) {
                                isDepthSocketConnected = false;
                                if (socketStatusListener) {
                                    socketStatusListener(false);
                                }
                            }
                        }
                        return;
                    }
                    const eventData = uintToJson(e.data);
                    // Handle SOCKET_STATUS events (only fire listener when state actually changes)
                    if (eventData.eventType === 'SOCKET_STATUS') {
                        const connected = ((_a = eventData.data) === null || _a === void 0 ? void 0 : _a.isConnected) === true;
                        if (isDepthSocketConnected !== connected) {
                            isDepthSocketConnected = connected;
                            if (socketStatusListener) {
                                socketStatusListener(connected);
                            }
                        }
                    }
                    handleAndDispatchMessage(eventData.eventType, eventData.data);
                }
                catch (error) {
                    console.error(error);
                }
            };
        }
    }
    else {
        onFocusChange(true);
    }
};
export const subscribeTo5DepthData = (subscriptionMethod, subscriberName, callBackMethod) => {
    let subsData = subscriberList.find((singleSubData) => {
        if (subscriptionMethod.Method === singleSubData.Method) {
            return singleSubData;
        }
    });
    if (subsData) {
        subsData.MarketFeedData.push(...subscriptionMethod.MarketFeedData);
        // scripMap
        subsData.MarketFeedData = arrayUnique(subsData.MarketFeedData);
    }
    else {
        subsData = subscriptionMethod;
        subscriberList.push(subscriptionMethod);
    }
    subscriptionMethod.MarketFeedData.forEach((singleElement) => {
        if (callBackMethod) {
            const isNew = addSingleScripSubscriber(subscriberName, singleElement, callBackMethod, subscriptionMethod.Method);
        }
    });
    publishMessage("SUBSCRIBE", {
        ...subscriptionMethod,
        subscriberName,
    });
    // }
};
const addSingleScripSubscriber = (subscriberName, marketFeedSingleElement, callBackMethod, methodName) => {
    let scripObj = scripMap[marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode];
    if (scripObj) {
        const subsObj = scripObj.subscribers.find((singleElement) => {
            const isAlreadySubscribed = singleElement.componentName == subscriberName;
            return isAlreadySubscribed;
        });
        if (subsObj) {
            const alreadySubscribedMethod = subsObj.method.find((singleElement) => {
                return singleElement == methodName;
            });
            //Just updating it in case there was rerender.Ideally this component itself will not call again
            subsObj.callback = callBackMethod;
            if (checkIsEmpty(alreadySubscribedMethod)) {
                subsObj.method.push(methodName);
                return true;
            }
            else {
                return false;
            }
        }
        else {
            scripObj.subscribers.push({
                method: [methodName],
                callback: callBackMethod,
                componentName: subscriberName,
            });
            return true;
        }
    }
    else {
        scripObj = {
            subscribers: [
                {
                    method: [methodName],
                    callback: callBackMethod,
                    componentName: subscriberName,
                },
            ],
            data: undefined,
            lastUpdateTime: undefined,
        };
        scripMap[marketFeedSingleElement.Exch +
            marketFeedSingleElement.ExchType +
            marketFeedSingleElement.ScripCode] = scripObj;
        return true;
    }
};
export const unsubscribeDataBySubscriber = (subscriberName, methodName) => {
    publishMessage(SOCKET_EVENT.UNSUBSCRIBE_BY_SUBSCRIBER, {
        subscriberName,
        methodName,
    });
    Object.keys(scripMap).forEach((singleScripKey) => {
        unSubscribeDataByScripKey(subscriberName, singleScripKey, methodName);
    });
};
export const unsubscribeDataByScrip5Depth = (subscriberName, marketFeedSingleElement, methodName) => {
    publishMessage(SOCKET_EVENT.UNSUBSCRIBE, {
        subscriberName,
        scripData: marketFeedSingleElement,
        methodName,
    });
    unSubscribeDataByScripKey(subscriberName, getScripKey(marketFeedSingleElement), methodName);
};
const unSubscribeDataByScripKey = (subscriberName, singleScripKey, methodName) => {
    const scripObj = scripMap[singleScripKey];
    if (scripObj) {
        if (checkIsEmpty(methodName)) {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName != subscriberName;
            });
            if (newSubList.length > 0) {
                scripObj.subscribers = newSubList;
            }
            else {
                delete scripMap[singleScripKey];
            }
        }
        else {
            const newSubList = scripObj.subscribers.filter((singleElement) => {
                return singleElement.componentName == subscriberName;
            });
            if (newSubList.length > 0) {
                const newMethodList = newSubList[0].method.filter((singleMethod) => {
                    return singleMethod != methodName;
                });
                if (newMethodList.length > 0) {
                    newSubList[0].method = newMethodList;
                }
                else {
                    //Recursive call as we need to remove the subscriber itself
                    unSubscribeDataByScripKey(subscriberName, singleScripKey);
                }
            }
        }
    }
};
const arrayUnique = (array) => {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
            if (a[i].ScripCode == a[j].ScripCode && a[i].Exch == a[j].Exch)
                a.splice(j--, 1);
        }
    }
    return a;
};
const getScripKey = (marketFeedSingleElement) => {
    return (marketFeedSingleElement.Exch +
        marketFeedSingleElement.ExchType +
        marketFeedSingleElement.ScripCode);
};
const handleAndDispatchMessage = (methodName, message) => {
    if (message) {
        if (message.ReqType) {
            if (rawMessageListener) {
                rawMessageListener(message);
            }
        }
        const key = message.Exch + message.ExchType + message.Token + "";
        const scripObj = scripMap[key];
        if (scripObj) {
            scripObj.lastUpdateTime = new Date();
            const isDataSubscribed = checkAnddispatchDataUsingCallBack(scripObj, message, methodName);
        }
    }
};
const checkAnddispatchDataUsingCallBack = (scripObj, message, methodName) => {
    let isDataSubscribed = false;
    scripObj.subscribers.forEach((singleSubscriber) => {
        let localSubsribed = false;
        singleSubscriber.method.forEach((singleMethod) => {
            if (singleMethod == methodName) {
                isDataSubscribed = true;
                localSubsribed = true;
            }
        });
        if (localSubsribed && singleSubscriber.callback) {
            singleSubscriber.callback(message);
        }
    });
    return isDataSubscribed;
};
export const onFocusChange = (isWindowFocused, focusScripCode) => {
    publishMessage(SOCKET_EVENT.IS_WINDOW_FOCUSED, isWindowFocused, focusScripCode);
};
export const heartBeatData = (subscriptionMethod, subscriberName, callbackMethod) => {
    return subscribeToData(subscriptionMethod, subscriberName, callbackMethod);
};
